(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zipper-image-swatches')) {
    class ZipperImageSwatches extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick = (event) => {
        const button = event.target.closest('.zip-image-swatch');
        if (!button || !this.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();

        const card = this.closest('product-card');
        const gallery = card?.querySelector('.card-gallery');
        if (!gallery) return;

        let preview = gallery.querySelector('.zip-swatch-preview');

        if (preview && button.getAttribute('aria-pressed') === 'true') {
          preview.remove();
          button.setAttribute('aria-pressed', 'false');
          return;
        }

        if (!preview) {
          preview = document.createElement('a');
          preview.className = 'zip-swatch-preview';
          preview.append(document.createElement('img'));

          preview.addEventListener('click', (e) => {
            e.stopPropagation();
          });

          gallery.append(preview);
        }

        preview.href = button.dataset.url;
        preview.setAttribute('aria-label', button.dataset.alt);

        const image = preview.querySelector('img');
        image.src = button.dataset.image;
        image.alt = button.dataset.alt;

        this.querySelectorAll('.zip-image-swatch').forEach((thumb) => {
          thumb.setAttribute('aria-pressed', String(thumb === button));
        });
      };
    }

    customElements.define('zipper-image-swatches', ZipperImageSwatches);
  }
  } catch(e) { console.error(e); }
})();

})();
